import Application from "../../Application";
import { IReportingPeriodService } from "../../service/reporting/ReportingPeriodService";

export default class GetReportingPeriodsInteractor {
  private application: Application;
  private reportingPeriodService: IReportingPeriodService;

  constructor(application, reportingPeriodService) {
    this.application = application;
    this.reportingPeriodService = reportingPeriodService;
  }

  async execute() {
    return this.reportingPeriodService.getReportingPeriods();
  }
}
